<template>
  <div>
        <kendo-grid
            ref="grid" 
            :data-source="dataSource"
            :filterable="filterableConfig"
            :sortable="true"
            :pageable="pageableConfig"
            :columns="columns"
            v-on:detailinit="detailInit"
            :resizable="true">
        </kendo-grid>
  </div>
</template>


<script>
import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
import {globalfunc} from '../../../../shared/GlobalFunction.js';
import invoiceDownPaymentService from '../Script/InvoiceDownPaymentScript.js';
import { kendo_grid } from '../../../../infrastructure/constant/variable.js';
import { apiBaseUrl } from '../../../../infrastructure/constant/connection';

export default {
    name: 'InvoiceDownPaymentGrid',
    components: {
        'kendo-grid' : Grid,
        'kendo-grid-column': GridColumn,
    },
    props: ['editClick', 'deleteClick', 'statusClick', 'invoiceDownPaymentClick'],
    data: function () {
        return  {
            dataSource:  new kendo.data.DataSource ({
                page: 1,
                pageSize: 50,
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                transport: {
                    read: {
                        contentType: "application/json",
                        url: apiBaseUrl,
                        type: "POST",
                        data: function(e) {
                            var swapfield = [
                                // { field: "status", new_field: "\"transaction_proforma_invoice\".\"status\"" },
                                // { field: "customer_name", new_field: "\"Customer\".\"contact_name\"" },
                                // { field: "notes", new_field: "\"transaction_proforma_invoice\".\"notes\"" },   
                                // { field: "created_by", new_field: "\"Created\".\"myname\"" },                            
                            ];
                            const paging = {
                                Page : {Limit: e.pageSize,Page: e.page},
                                Filter : globalfunc.filterQueryBuilder(e.filter, swapfield),
                                OrderBy : globalfunc.sortingQueryBuilder(e.sort, swapfield)
                            }
                            const variables = {
                                paging : paging
                            }
                            return { 
                                query: invoiceDownPaymentService.readInvoiceDownPaymentQuery(),
                                variables : variables
                            };
                        },
                        beforeSend: function (req) {
                            req.setRequestHeader('Authorization', window.$cookies.get('Token'));
                            req.setRequestHeader('Path', window.location.pathname);
                        }
                    },
                    parameterMap: function(options, operation) {
                        return  kendo.stringify({
                            query: options.query,
                            variables: options.variables
                        });
                    },
                    cache: false,
                },
                schema: {
                    data: function (response) {
                        if(response.data.GetTransactionDownPayment.transaction_down_payment == null){
                            return [];
                        }else{
                            return response.data.GetTransactionDownPayment.transaction_down_payment;
                        }
                    },
                    total: function (response) {
                        if(response.data.GetTransactionDownPayment.transaction_down_payment == null){
                            return 0;
                        }else{
                            return response.data.GetTransactionDownPayment.total;
                        }
                    },
                    model: {
                        fields: {
                            total: {type: "number"}
                        }
                    }
                }
            }),
            columns:  [
                { title: "Action", width: 150, attributes: { style: "text-align:center;" }, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, template:this.columnButton},
                { field: "status", title: "Status", width: 90, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, attributes:{style: "text-align:center;"} }, 
                { field: "down_payment_number", title: "No. Invoice", width: 150, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                { field: "customer_name", title: "Customer", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" } }, 
                { field: "project_name", title: "Nama Project", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                { field: "total", title: "Total", width: 130, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, attributes:{style: "text-align:right;"},
                    template: "#= kendo.toString(Math.round(total), 'n') #" },
                { field: "notes", title: "Catatan", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                { field: "created_by", title: "Dibuat Oleh", width: 150, headerAttributes:{ style: "text-align:center; font-weight:bold;" } }, 
            ],
            filterableConfig:  {
                extra: true,
                operators: kendo_grid.default_operator
            },
            pageableConfig: kendo_grid.default_pageable_config,
        };
    },
    mounted: async function() {
        var grid = this.$refs.grid.kendoWidget();
        var deleteClick = this.$props.deleteClick;
        var editClick = this.$props.editClick;
        var invoiceDownPaymentClick = this.$props.invoiceDownPaymentClick;

        var GridElement = grid.element;

        GridElement.on("click", "#DeleteButton", function (e){
            e.preventDefault();
            var dataItem = grid.dataItem(e.target.closest("tr"));

            deleteClick(dataItem.down_payment_id);
        })

        GridElement.on("click", "#EditButton", function (e){
            e.preventDefault();
            var dataItem = grid.dataItem(e.target.closest("tr"));

            editClick(dataItem.down_payment_id, false);
        })

        GridElement.on("click", "#ViewButton", function (e){
            e.preventDefault();
            var dataItem = grid.dataItem(e.target.closest("tr"));
            
            editClick(dataItem.down_payment_id, true);
        })

        GridElement.on("click", "#InvoiceDownPaymentButton", function (e){
            e.preventDefault();
            var detailGrid = $(e.target).closest(".k-grid").data("kendoGrid");

            if (detailGrid) {
                var detailDataItem = detailGrid.dataItem($(e.target).closest("tr"));
                if (detailDataItem) {
                    invoiceDownPaymentClick(detailDataItem.down_payment_id, detailDataItem.id, detailDataItem.down_payment_number, detailDataItem.date);
                }
            }
        })
    },
    methods: {
        columnButton(){
            return this.$globalfunc.gridActionButton("Purchase Order");
        },
        detailColumnButton(){
            var customButton = `<button type="button" class="btn btn-warning btn-sm rounded" id="InvoiceDownPaymentButton">
                                    <i class="fa fa-file-pdf-o"></i> </span>
                                </button>`;
            return customButton;
        },
        detailInit: async function (e) {
            var data = await invoiceDownPaymentService.getInvoiceDownPaymentQuery(e.data.down_payment_id);
            var itemDetail = invoiceDownPaymentService.editItemGridDataGenerator(data.transaction_down_payment_details);

            var totalPPNTax = 0;
            var totalGrossDisc = 0;
            var grandTotal = 0;

            if(itemDetail.length > 0){
                itemDetail.forEach(e => {
                    totalGrossDisc = totalGrossDisc + (e.net * e.qty);
                    totalPPNTax = totalPPNTax + (e.net * (data.tax_percentage / 100)) * e.qty;
                });
            }

            grandTotal = totalGrossDisc + Math.round(totalPPNTax);
            var itemMergeArray = invoiceDownPaymentService.itemArray(itemDetail);

            $('<div/>').appendTo(e.detailCell).html('<label class="form-label"><b>Daftar Barang</b></label>');
            $('<div/>').appendTo(e.detailCell).kendoGrid({
                ref: "detailGrid",
                dataSource: {
                    transport: {
                        read: function (x) {
                            x.success(itemMergeArray);
                        },
                    },
                    parameterMap: function(options, operation) {
                        return kendo.stringify(
                            {
                                query: options.query,
                                variables: options.variables
                            }
                        );
                    },
                    schema: {
                        data: function (response) {
                            if(response == null)
                                return [];
                            else
                                return response;
                        },
                        total: function(response) {
                            if(response == null)
                                return 0;
                            else
                                return response.length;
                        }
                    },
                    pageSize: kendo_grid.default_detail_grid_pagesize,
                    group: { field: "type", aggregates: [ {field: "total_price", aggregate: "sum"} ] },
                    aggregate: [{ field: "total_price", aggregate: "sum" }]
                },
                scrollable: false,
                sortable: true,
                pageable: true,
                navigatable: true,
                editable: false,
                resizable: true,
                columns: [
                    { field: "type", title: "Tipe", headerAttributes:{ style: "text-align:center; font-weight:bold;" }, 
                        groupHeaderTemplate: "#= value #", hidden: true},
                    { field: 'quantity', title: "Jumlah", width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, attributes: { "class": "k-text-right" } },
                    { field: 'uom', title: "Satuan", width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                    { field: 'product_code', title: "Kode Barang", width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                    { field: 'item_name', title: "Nama Barang", width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                    { field: 'vat_per_unit', title: "Harga", width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, format: "{0:N0}", attributes: { "class": "k-text-right" }, 
                        footerTemplate: `   <div style='float: right'>Total</div><br>
                                            <div style='float: right'>PPN `+ data.tax_percentage +`%</div><br>
                                            <div style='float: right'>Grand Total</div>` },
                    { field: 'total_price', title: "Total",  width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, format: "{0:N0}", attributes: { "class": "k-text-right" }, 
                        aggregates: ["sum"],  footerTemplate: ` <div style='float: right'>Rp. #=  kendo.toString(Math.round(sum), 'n0') #</div><br>
                                                                <div style='float: right'>Rp. #=  kendo.toString(`+ totalPPNTax +`, 'n0') #</div><br>
                                                                <div style='float: right'>Rp. #=  kendo.toString(`+ grandTotal +`, 'n0') #</div>` },
                ],
            });

            $('<div/>').appendTo(e.detailCell).html('<hr>');
            
            var detailData = invoiceDownPaymentService.downPaymentEventGridDataGenerator(data.transaction_down_payment_events, data.down_payment_id, data.down_payment_number);
        
            $('<div/>').appendTo(e.detailCell).html('<label class="form-label"><b>Down Payment Event</b></label>');
            $('<div/>').appendTo(e.detailCell).kendoGrid({
                ref: "detailGrid",
                dataSource: {
                    transport: {
                        read: function (x) {
                            x.success(detailData);
                        },
                    },
                    parameterMap: function(options, operation) {
                        return kendo.stringify(
                            {
                                query: options.query,
                                variables: options.variables
                            }
                        );
                    },
                    schema: {
                        data: function (response) {
                            if(response == null)
                                return [];
                            else
                                return response;
                        },
                        total: function(response) {
                            if(response == null)
                                return 0;
                            else
                                return response.length;
                        }
                    },
                    pageSize: kendo_grid.default_detail_grid_pagesize,
                },
                scrollable: false,
                sortable: true,
                pageable: true,
                navigatable: true,
                editable: false,
                resizable: true,
                columns: [
                    { title: "Action", width: 50, attributes: { style: "text-align:center;" }, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, template:this.detailColumnButton},
                    { field: 'amount', title: "Uang Muka", width: 100, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, attributes: { "class": "k-text-right" } },
                    { field: "date", title: "Tanggal Uang Muka", width: 125, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, attributes:{style: "text-align:center;"},
                        template: "#= kendo.toString(kendo.parseDate(date, 'yyyy-MM-dd'), 'yyyy-MM-dd') #" },
                    { field: "notes", title: "Catatan", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" } },
                    { field: "created_by", title: "Dibuat Oleh", width: 150, headerAttributes:{ style: "text-align:center; font-weight:bold;" } }, 
                ],
            });
        }
    }
}
</script>